import { keyframes, styled } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import { getLatestAnnouncement } from 'api/v1/message'
import Iconfont from 'components/Iconfont'
import dayjs from 'dayjs'
import React, { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateShowMandatoryToast } from 'store/settings/actions'
import { useMandatoryToast } from 'store/settings/hooks'
import { Flex, FlexBetween, FlexColumn } from 'styles'

const AnimationRight = keyframes`
  0% {
    display: flex;
    right: -200%;
  }
  100% {
    display: flex;
    right: 20px;
  }
`
const Wrap = styled(FlexColumn)`
  position: fixed;
  right: -200%;
  top: 76px;
  max-width: 340px;
  padding: 24px 16px;
  box-shadow: 0px 20px 25px -5px rgba(0, 0, 0, 0.1),
    0px 10px 10px -5px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  background: ${(props) => props.theme.color.bg};
  z-index: 99;
  display: none;
  border: 1px solid ${(props) => props.theme.color.text20};

  &.show {
    display: flex;
    right: 20px;
    animation: ${AnimationRight} 2s 1 linear;
  }
  .checkbox {
    > span {
      margin-left: -9px;
    }
  }
  ${(props) => props.theme.breakpoints.down('md')} {
    max-width: 90%;
    right: -100%;
    &.show {
      right: 5%;
      animation: ${AnimationRight} 1s 1 linear;
    }
  }
`

const Head = styled(FlexBetween)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.color.text100};
  align-items: flex-start;

  .iconfont {
    color: ${(props) => props.theme.color.text60};
    &.icon {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 0 0 24px;
      height: 24px;
      margin-right: 6px;
      border: 1px solid ${(props) => props.theme.color.text60};
      border-radius: 50%;
    }
  }
  .close-wrap {
    cursor: pointer;
  }
`
const Content = styled(Flex)`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  border-radius: 4px;
  background: ${(props) => props.theme.color.bgGray};
  color: ${(props) => props.theme.color.text90};
  padding: 8px 10px;
  margin-top: 8px;
  p {
    margin-top: 0;
    &:last-child {
      margin-bottom: 0;
    }
    a {
      color: ${(props) => props.theme.color.primary40};
    }
  }
`
const CheckWrap = styled(Flex)`
  font-size: 12px;
  line-height: 14px;
  border-radius: 4px;
  height: 42px;
  align-items: center;
  color: ${(props) => props.theme.color.text60};
`

export const MandatoryToast = memo(() => {
  const dispatch = useDispatch()
  const [showToast, setShowToast] = useState<boolean>(false)
  const [checked, setChecked] = useState<boolean>(false)

  const mandatoryToast = useMandatoryToast()
  useEffect(() => {
    getNotifiesData()
  }, [])
  useEffect(() => {
    if (mandatoryToast) {
      const { expirationTime } = mandatoryToast
      if (new Date().getTime() > expirationTime) {
        setShowToast(true)
      } else {
        setShowToast(false)
      }
    }
  }, [mandatoryToast])
  const handleCloseToast = () => {
    setShowToast(false)
    dispatch(
      updateShowMandatoryToast({
        ...mandatoryToast,
        expirationTime: dayjs().add(1, 'hour').unix() * 1000,
      })
    )
  }
  const handleCheckClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked
    setChecked(checked)
    if (checked) {
      setShowToast(false)
      dispatch(
        updateShowMandatoryToast({
          ...mandatoryToast,
          expirationTime: dayjs().add(7, 'day').unix() * 1000,
        })
      )
    }
  }
  const getNotifiesData = async () => {
    try {
      const Announcement = await getLatestAnnouncement()
      if (Announcement) {
        const { content, title, id, expirationDate } = Announcement.data
        dispatch(
          updateShowMandatoryToast({
            ...mandatoryToast,
            content,
            title,
            id,
          })
        )
      } else {
        dispatch(
          updateShowMandatoryToast({
            id: 0,
            expirationTime: 0,
            content: '',
            createdAt: 0,
            notifyType: 1,
            title: '',
          })
        )
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <>
      {mandatoryToast && mandatoryToast.id ? (
        <Wrap className={`${showToast ? 'show' : ''}`}>
          <Head>
            <Iconfont
              className={'icon'}
              name="icon-Notis_Mobile"
              size={16}></Iconfont>
            {mandatoryToast.title}
            <span onClick={() => handleCloseToast()} className="close-wrap">
              <Iconfont name="icon-close2" size={20}></Iconfont>
            </span>
          </Head>

          <Content>
            <div
              dangerouslySetInnerHTML={{
                __html: mandatoryToast.content,
              }}></div>
          </Content>
          <CheckWrap className={'checkbox'}>
            <Checkbox checked={checked} onChange={handleCheckClick} />
            <span> Don't show this message again for 7 days.</span>
          </CheckWrap>
        </Wrap>
      ) : null}
    </>
  )
})
